import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { PublicTransitLayerEntityName } from '@api/entities/replancity_PublicTransitLine';
import { useTypedSelector } from '@redux/Hooks/storeSelectors';
import { selectMapLayerIdByEntityName } from '@redux/selectors/selectors';
import EntityEditor from '../../../entities/EntityEditor';

const TransitLineEdit = () => {
    const entityName = PublicTransitLayerEntityName.LINES;
    const routesEntityName = PublicTransitLayerEntityName.ROUTES;
    const { lineId } = useParams<any>();
    const sourceId = useTypedSelector(state =>
        selectMapLayerIdByEntityName(state, routesEntityName)
    );

    //TODO there was check if lineId exists previously
    const onSaveFn = useCallback((entity: any) => {
        if (lineId) {
            return `../../${entity.id}/edit`;
        }
        return `../${entity.id}/edit`;
    }, []);

    const onDeleteFn = useCallback(() => `../../`, []);

    //TODO check response view params in saveFn. there was params: {responseView: 'form'},

    return (
        <EntityEditor
            entityId={lineId!}
            entityName={entityName}
            layerId={sourceId}
            presetProperty={'publicTransitPreset'}
            getUrlOnSaveFn={onSaveFn}
            getUrlOnDeleteFn={onDeleteFn}
            showDeleteBtn={!!lineId}
        />
    );
};

export default TransitLineEdit;
